export const Device = Object.freeze({
  ANDROID: "Android",
  IOS: "iOS",
  DESKTOP: "Desktop",
});
